import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Spin } from '@crosscode/gravity-components'
import { useAuth } from '@/app/AuthProvider'
import { NAV_ITEMS } from '@/shared/permissions'

export function AuthGate({ children }: { children?: React.ReactNode }) {
  const { user, loading, hasPermission } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <Spin size="large" description="Загрузка…" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  const item = NAV_ITEMS.find(
    (n) => n.path === location.pathname || location.pathname.startsWith(n.path + '/'),
  )

  if (item?.adminOnly && user.id !== 1) {
    const first = NAV_ITEMS.find(
      (n) => (!n.adminOnly || user.id === 1) && hasPermission(n.permission),
    )
    return <Navigate to={first?.path || '/'} replace />
  }

  if (item?.permission && !hasPermission(item.permission)) {
    const first = NAV_ITEMS.find(
      (n) => (!n.adminOnly || user.id === 1) && hasPermission(n.permission),
    )
    return <Navigate to={first?.path || '/'} replace />
  }

  return children ? <>{children}</> : <Outlet />
}
